import React, { useState } from "react";
import { Link } from "gatsby";
import "./PropertyCard.scss";
// import PlayVideo from "../../Components/Play/PlayVideo";

import NoImage from "../../../images/pittis-no-image.png"
import ImageTransform from "../../common/ggfx-client/module/components/image-transform";

const PropertyCard = (props) => {

  const [show, setShow] = useState(false);

  const handleClick = () => {
    setShow(!show);
  }


  const ImageRender = ({ image_url, node, processedImages }) => {
    return (
      <img src={image_url} alt="" />
      // <ImageTransform imagesources={image_url} renderer="srcSet" imagename="property.images.searchResults1" attr={{ alt: '', class: '' }} imagetransformresult={processedImages} id={node.crm_id} format="source" />
    )
  }

  const pageurl = typeof window !== 'undefined' ? window.location.href : ''

  return (
    <React.Fragment>
      <div className={`property-card img-zoom ${props.showcased_property ? 'box-blue' : props.spotlight_property ? 'box-yellow' : ''}`} id={props.objectID}>
        <div className="properties-wrapper">
          <Link to={`${props.url}`} className="img-link">
            <picture>
              {props.image_url ?
                <ImageRender processedImages={props.processedImages} image_url={props.image_url} node={props} />
                :
                <img src={NoImage} alt="img" />
              }
              {/* <img src={props.ImgLarge} alt="img" /> */}
            </picture>
            {props.showcased_property ?
              <span className="card-line">Showcased Property</span> :
              props.spotlight_property ?
                <span className="card-line">spotlighted Property</span> : ''}

            <div className="btn-group-wrap">
              <button className="btn-camera"><i className="icon-camera-gallery"></i> <span>1/4</span></button>
              {props.virtual_tour &&
                <button className="btn-play-circle"><i className="icon-play-circle"></i></button>
              }
              <button className="btn-flor"><i className="icon-flor"></i> </button>
            </div>
          </Link>
        </div>
        <div className="about-properties grid-prop-info">

          <div className="properties-info">

            <h2 onClick={handleClick}>

              <Link to={`${props.url}`} className="img-link">
                {props.PropertyHeading}
              </Link>
              {props.loginstatus == "true" ?
                <i id={props.crm_id} className={props.wish == "true" ? "icon-heart-fill" : "icon-heart"} onClick={() => { props.handleSecond(props.crm_id); }}></i> :
                <a href={`https://myaccount.pittis.co.uk/Account/MainSiteLogin/?returnUrl=${pageurl}&id=${props.crm_id}`}>
                  <i id={props.crm_id} className="icon-heart"></i>
                </a>
              }
            </h2>
            <span className="property-price">{props.currency == 'no' ? '' : '£'}{props.PropertyPrice ? props.PropertyPrice.toLocaleString() : 0} {props.search_type == "lettings" ? ' PCM' : ''}</span>
            <p>{props.PropertyText}</p>
          </div>

          {props.type != "new-homes" ?
            <div className="properties-icons">
              <span className="text">
                <i className="icon-bedroom"></i>
                <span className="sm-text">{props.BedCount}</span>
              </span>
              <span className="text">
                <i className="icon-bath"></i>
                <span className="sm-text">{props.BathCount}</span>
              </span>
              <span className="text">
                <i className="icon-sofa"></i>
                <span className="sm-text">{props.areaSup}</span>
              </span>
            </div> : ''
          }
        </div>

      </div>
    </React.Fragment>
  );
};

export default PropertyCard;
